import { render, staticRenderFns } from "./theorie-examen-oefenen.vue?vue&type=template&id=2e2edc2c"
import script from "./theorie-examen-oefenen.vue?vue&type=script&lang=js"
export * from "./theorie-examen-oefenen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports